import React from "react"
import { useStaticQuery, graphql, Link } from "gatsby"
import styled from "styled-components"
import Parser from "html-react-parser"
import excerptHtml from "excerpt-html"

// import material ui
import Typography from "@material-ui/core/Typography"

import Edges from "../_layout/edges"
import Socials from "./Socials"
import FooterLogo from "../../images/fraserview-logo-glyph.svg"

import * as theme from "../../theme"

const Footer = () => {
  const { copyright, footer_headline, products, socials } = useFooterQuery()
  const currentYear = new Date().getFullYear()

  return (
    <Container>
      <TopEdges size="lg">
        <FooterLogo className="footer-logo" />

        <TopBar>
          <Row>
            <div>
              <Headline variant="h5">{Parser(footer_headline)}</Headline>
              <Socials socials={socials} />
            </div>
            <List>
              {!!products &&
                products.map(item => {
                  return (
                    <ItemWrapper key={item.id}>
                      <Item to={item.pathname}>
                        <Typography variant="subtitle2">
                          {excerptHtml(
                            item.post_title.replace("Western Red Cedar ", ""),
                            {
                              pruneLength: 20,
                              pruneString: "…"
                            }
                          )}
                        </Typography>
                      </Item>
                    </ItemWrapper>
                  )
                })}
            </List>
          </Row>
        </TopBar>
      </TopEdges>

      <BottomBar>
        <BottomEdges size="lg">
          <Copyright>
            &copy; {currentYear} {copyright}{" "}
          </Copyright>
          <Copyright>
            {/* eslint-disable-next-line */}
            <a href="https://bare.ca/" target="_blank">
              Gatsby site development by Bare
            </a>
          </Copyright>
        </BottomEdges>
      </BottomBar>
    </Container>
  )
}

export default Footer

const Container = styled.div`
  @media (min-width: 600px) {
    margin-top: 160px;
  }
  margin-top: 80px;
  min-height: 230px;
  position: relative;
  background: #4a4a4a;
  width: 100%;
  .footer-logo {
    path,
    polygon {
      fill: ${theme.color.green};
    }
    width: 200px;
    @media (min-width: 600px) {
      width: 25%;
    }
    max-width: 200px;
    padding: 10px 0;
  }
`
const TopEdges = styled(Edges)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
`
const TopBar = styled.div`
  position: relative;
  z-index: 5;
  padding: 30px 0;
  display: flex;
  @media (min-width: 600px) {
    width: 75%;
  }
`
const BottomEdges = styled(Edges)`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  position: relative;
  z-index: 5;
`
const BottomBar = styled.div`
  padding: 8px 15px;
  background: #3a3a3a;
  width: 100%;
`
const Headline = styled(Typography)`
  color: white;
  font-size: 1.125rem;
  line-height: 1.125;
  padding-right: 60px;
  padding-top: 8px;
  padding-bottom: 8px;
`
const List = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
`
const ItemWrapper = styled.div`
  @media (min-width: 320px) {
    width: 50%;
  }

  @media (min-width: 820px) {
    width: calc(100% / 3);
  }
  width: 100%;
`

const Item = styled(Link)`
  text-decoration: none;
  color: white;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
  display: inline-block;
  &:hover {
    &:after {
      transform: scaleX(1);
    }
  }
  &:after {
    transform-origin: 0 100%;
    display: block;
    content: "";
    border-bottom: solid 2px white;
    transform: scaleX(0);
    transition: transform 150ms ease-in-out;
  }
`
const Row = styled.div`
  display: flex;
  align-items: flex-start;
  @media (max-width: 800px) {
    flex-direction: column;
  }
`
const Copyright = styled(Typography)`
  color: white;
  z-index: 5;
  a {
    color: white;
    text-decoration: none;
    display: inline-block;
    &:hover {
      &:after {
        transform: scaleX(1);
      }
    }
    &:after {
      transform-origin: 0 100%;
      display: block;
      content: "";
      border-bottom: solid 2px white;
      transform: scaleX(0);
      transition: transform 150ms ease-in-out;
    }
  }
`

const useFooterQuery = () => {
  const response = useStaticQuery(
    graphql`
      {
        wordsbyData {
          footer_headline
          copyright
          socials {
            icon
            url
          }
        }
        allWordsbyCollections(filter: { post_type: { eq: "product" } }) {
          edges {
            node {
              id
              post_title
              pathname
            }
          }
        }
      }
    `
  )
  const {
    allWordsbyCollections: { edges },
    wordsbyData
  } = response

  let nodes
  if (edges) {
    nodes = edges.map(node => node.node)
  }

  const data = { products: nodes, ...wordsbyData }
  return data
}
